module.exports = __webpack_public_path__ + "static/media/Group.ae6aa45c.png";